/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateVariantMutationRequest,
  UpdateVariantMutationResponse,
  UpdateVariantPathParams,
  UpdateVariant400,
  UpdateVariant404,
} from '../types/UpdateVariant'

function getUpdateVariantUrl({ id }: { id: UpdateVariantPathParams['id'] }) {
  const res = {
    method: 'PUT',
    url: `/api/v1/products/catalog/variants/${id}/` as const,
  }
  return res
}

/**
 * @description Update a variant.
 * PUT /variants/{pk}/
 * Args:
 * request: The request object
 * pk: Variant ID
 * Returns:
 * Response with updated variant data or error
 * @summary Update a variant
 * {@link /api/v1/products/catalog/variants/:id/}
 */
export async function updateVariant(
  { id }: { id: UpdateVariantPathParams['id'] },
  data: UpdateVariantMutationRequest,
  config: Partial<RequestConfig<UpdateVariantMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateVariantMutationResponse,
    ResponseErrorConfig<UpdateVariant400 | UpdateVariant404>,
    UpdateVariantMutationRequest
  >({
    method: 'PUT',
    url: getUpdateVariantUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
